import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '../../../../app/form/switch/switch';
import { IconCheck } from '../../../../app/icons/check';
import { Tooltip } from '../../../../app/tooltip/tooltip';
import { useCompoundInterestCalculatorContext } from '../../calculator-context/compound-interest-calculator-context';

export const CompoundInterestTaxExemptionToggle: React.FC = () => {
    const { t } = useTranslation();
    const { isTaxExemptionByTestEnabled, handleTaxExemptionByTestChange } = useCompoundInterestCalculatorContext();

    return (
        <div className="flex min-h-[4rem] w-full flex-nowrap items-center justify-between gap-[1rem] vl:justify-start">
            <span className="text-small font-medium text-text-muted">
                <Tooltip
                    icon
                    content={t('pages.compoundInterest.calculator.taxExemptionByTestTooltip')}
                    position="bottom-right"
                >
                    {t('pages.compoundInterest.calculator.taxExemptionByTest')}
                </Tooltip>
            </span>
            <Switch
                variant="primary"
                checked={isTaxExemptionByTestEnabled}
                name="compoundInterestTaxExemptionByTest"
                iconOff={' '}
                iconOn={<IconCheck />}
                onChange={handleTaxExemptionByTestChange}
            />
        </div>
    );
};
